module.exports = __webpack_public_path__ + "static/media/Sharp-LCD-Specification-LQ190E1LX76-4-11-18.01f7a0a0.pdf";